import React, { ReactNode, useState, useEffect } from 'react';
import { useQuery } from '@apollo/react-hooks';
import SETTING_IMPROVEMENTS_LIST_QUERY, {
  SettingImprovementsListVars,
  SettingImprovementsListData,
  SettingImprovementsList,
} from 'shared/graphql/query/settingImprovements';
import { Select, message, Empty } from 'antd';
import useMessageError from 'shared/hooks/useMessageError';

type SelectDriverProps = {
  value?: string;
  disabled?: boolean;
  onChange?: (values?: SettingImprovementsList) => void;
  placeholder?: string;
};

const { Option } = Select;

const SelectDriver: React.FC<SelectDriverProps> = (props) => {
  const { value, disabled, onChange, placeholder } = props;
  const [search, setSearch] = useState<string>('');
  const [improvementsList, setImprovementsList] = useState<SettingImprovementsList[]>([]);
  const { getMessageError } = useMessageError();

  const { data, loading, error } = useQuery<
    SettingImprovementsListData,
    SettingImprovementsListVars
  >(SETTING_IMPROVEMENTS_LIST_QUERY, {
    variables: {
      params: {
        name: search,
        // active_status: true,
      },
    },
    onError: (err) => {
      message.error(getMessageError(err));
    },
    fetchPolicy: 'cache-and-network',
  });

  useEffect(() => {
    if (!loading && !error && data?.settingImprovements) {
      setImprovementsList([...data.settingImprovements.settingImprovements]);
    }
  }, [data?.settingImprovements, loading, error]);

  const options: ReactNode[] = improvementsList.map((item) => (
    <Option key={item._id} value={item._id}>{`${item.name}`}</Option>
  ));

  const onSelected = (valueInput: string) => {
    if (onChange && valueInput === undefined) {
      onChange(undefined);
    }

    const findValue = improvementsList.find((item) => item._id === valueInput);
    if (onChange && findValue) {
      onChange(findValue);
    }
  };

  return (
    <>
      <Select
        allowClear
        value={value && options.length ? value : undefined}
        disabled={disabled}
        loading={loading}
        placeholder={placeholder || 'เลือก'}
        onChange={(valueChange) => {
          setSearch('');
          onSelected(valueChange);
        }}
        showSearch
        onSearch={(valueSearch) => setSearch(valueSearch)}
        optionFilterProp="children"
        filterOption={false}
        notFoundContent={<Empty description="ไม่มีข้อมูล" image={Empty.PRESENTED_IMAGE_SIMPLE} />}
      >
        {options}
      </Select>
    </>
  );
};

export default SelectDriver;
